import {
	ready
} from '~/core'
import {
	bodyLock
} from '~/utils'
ready('filters', '.filters', (filters) => {

    let mql = window.matchMedia("(max-width: 992px)");
    // let filterMore = filters.getAttribute('data-textMore') || ''
    // let filterLess = filters.getAttribute('data-textLess') || ''

    function toggleFilters() {
        $('.filters').after($('<div class="filters-overlay">'));
        $('.js-filtersToggle, .filters-close, .filters-overlay').on('click.mql', function (event) {
            event.preventDefault();
            if (!$('body').hasClass('is-filtersOpen noScroll')) {
                $('body').addClass('is-filtersOpen noScroll');
                bodyLock.lock(filters)
            } else {
                $('body').removeClass('is-filtersOpen noScroll');
                bodyLock.unlock(filters)
            }
        });
    }

    function resetIt() {
        bodyLock.unlock(filters)
        $('.js-filtersToggle, .filters-close, .filters-overlay').off('click.mql');
        $('body').removeClass('is-filtersOpen noScroll');
        $('.js-filtersToggle').removeClass('is-active');
        $('.filters-overlay').remove();
    }

    function screenSize(mql) {
        if (mql.matches) {
            toggleFilters();
        } else {
            resetIt();
        }
    }

    // Handle media query 'change' event
    mql.addListener(screenSize);
    screenSize(mql);



    // Handle more than 5 Items in filters list
    // const listItemCount = [...filters.querySelectorAll('.filters-list')]

    // listItemCount.forEach(list => {
    //     let listLength = [...list.querySelectorAll('.filters-item')].length

    //     if (listLength > 5) {
    //         let viewAllToggle = $('<span></span>').addClass("filters-viewAll").html('See All')
    //         $(list).append(viewAllToggle);

    //         $(viewAllToggle).on('click', function () {
    //             if (!list.classList.contains('is-expanded')) {
    //                 list.classList.add('is-expanded');
    //                 $(viewAllToggle).text('See Less');
    //             } else {
    //                 list.classList.remove('is-expanded');
    //                 $(viewAllToggle).text('See All');
    //             }
    //         })
    //     }
    // });

});